import ProfileInfo from 'containers/employer/profile-stages/basic-info';
import OrganizationType from 'containers/employer/profile-stages/organization-type';
import OrganizationDetails from 'containers/employer/profile-stages/organization-details';
import OrganizationSize from 'containers/employer/profile-stages/organization-size';
import OrganizationOfficeAddress from 'containers/employer/profile-stages/organization-office-address';
// import WorkerType from 'containers/employer/profile-stages/worker-type';

export const defaultStage = {
  title: 'Pending',
  description: 'Pending',
  status: undefined,
  disabled: true,
  component: undefined,
};

const Stages = [
  ProfileInfo,
  // WorkerType,
  OrganizationType,
  OrganizationDetails,
  OrganizationSize,
  OrganizationOfficeAddress,
].map((stage) => ({ ...stage, disabled: false }));

export default Stages;
